import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class Muted extends BaseOption {
  static userInterfaceComponent = {
    label: "Muted",
    component: inspectorTools.RADIO_BAR,
    props: {
      options: [
        {
          icon: "mdi:speakerphone-off",
          tooltip: "Muted",
          value: "Yes",
        },
        {
          icon: "mdi:speakerphone",
          tooltip: "Unmuted",
          value: "No",
        },
      ],
    },
  };

  static defaultValue = "Yes";

  static convertConfigValueToCompiledValue(configValue) {
    return configValue === "Yes";
  }
}
